import React, { useEffect, useState } from 'react'
import { BiHide, BiShow } from 'react-icons/bi';
import { MdAddAPhoto, MdOutlineArrowBackIos } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { deleteGroup, getSingleGroup, updateGroupSettings } from '../../actions/groupActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from 'react-router-dom';
import { DELETE_GROUP_RESET, UPDATE_SETTINGS_RESET } from '../../constants/groupConstants';
const Default = require('../../assets/groupdefault.jpg');
const baseUrl = process.env.REACT_APP_IMAGES_BASEURL;

const GroupGeneral = () => {
    const [avatarPreview, setAvatarPreview] = useState(Default);
    const [grName, setGrName] = useState('');
    const [grDescription, setGrDescription] = useState('');
    const [grpasscode, setGrpasscode] = useState('');
    const [isPrivate, setIsPrivate] = useState(false);
    const [requirepasscode, setRequirepasscode] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [groupImage, setGrImage] = useState('');
    const [selectedGroupImage, setselectedGroupImage] = useState('');
    const [passcodeError, setPasscodeError] = useState(false);

    const { user } = useSelector(state => state.auth);
    const creator = user?._id;
    const { updatedSettings, loading: sloading, uploadedResource, error: groupUploadError, deletedGroup } = useSelector(state => state.group);
    const { group } = useSelector(state => state.groupDetails);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const showToastMessage = (message) => {
        toast.success(message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000
        });
    };

    useEffect (() => {
        if (group && group?.group?._id !== id) {
            dispatch(getSingleGroup(id, creator));
        } else {
            setGrName(group?.group?.name)
            setGrDescription(group?.group?.description)
            setGrpasscode(group?.group?.gpasscode)
            setAvatarPreview(group?.group?.groupImage?.url ? (group?.group?.groupImage?.public_id === null ? ((baseUrl + group?.group?.groupImage?.url)) : group?.group?.groupImage?.url) : Default)
            setIsPrivate(Boolean(group?.group?.isPrivate));
        }

        if (updatedSettings) {
            dispatch({ type: UPDATE_SETTINGS_RESET });
            dispatch(getSingleGroup(id, creator));
            setErrorMsg(false);
            showToastMessage("Updated settings successfully!");
        }
        
    }, [dispatch, group, id, updatedSettings]);

    useEffect(() => {
        if (deletedGroup) {
            dispatch({ type: DELETE_GROUP_RESET });
            showToastMessage("Group Deleted!");
            navigate('/groups')
        }
    }, [deletedGroup]);

    const updateSettings = (e) => {
        e.preventDefault();
        const MAX_FILE_SIZE = 1024 * 1024 * 10;
        if(selectedGroupImage.size > MAX_FILE_SIZE){
            setErrorMsg("File size cannot exceed 10Mbs");
            return
        }
        if(isPrivate && !grpasscode){
            setPasscodeError("Please enter a password for your private group");
            return
        }
        dispatch(updateGroupSettings(id, grName, grDescription, isPrivate, grpasscode, requirepasscode, groupImage));
    };

    const deleteGroupHandler = () => {
        dispatch(deleteGroup(id));
    };

    const onChange = e => {
        if(e.target.name === 'grimage') {
            const reader = new FileReader();
            reader.onload = () => {
                if (reader.readyState === 2) {
                    setAvatarPreview(reader.result)
                }
            }
            reader.readAsDataURL(e.target.files[0])
            setselectedGroupImage(e.target.files[0])
            setGrImage(e.target.files[0])
        } 
    }

  return (
    <div className='block'>
        <div className={'flex justify-between w-full items-center py-4 px-3 border-b border-gray-300'}>
            <MdOutlineArrowBackIos onClick={() => navigate(`/${id}/settings`)} /> 
            <p>Group Settings</p>
            <p></p>
        </div>
        <ToastContainer autoClose={1000} />
        <div className={"w-full py-3 px-4 "}>
            <div className={"w-full "}>
            
            <p className="error-message text-red-600">
                {/* {errorMsg} */}
            </p>
            <div className='gsgroupname'>
                <p className='gsgroupnamelabel'>Group Name</p>
                <input type="text" value={grName} onChange={(e) => setGrName(e.target.value)} className='gsinputgroup' />
            </div>
            <div className='gsgroupdescdiv'>
                <p className='gsgroupdesclabel'>Group Description</p>
                <input type="text" value={grDescription} onChange={(e) => setGrDescription(e.target.value)} className='gsinputgroupdesc w-full' />
            </div>
            <div className='flex flex-row justify-center items-center w-full py-2'>
                <div className="flex justify-center items-center h-[130px] w-[130px] rounded-lg border-2 bg-gray-100 border-gray-100" style={{ 
                        backgroundImage: `url(${avatarPreview})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat'
                    }}>
                    <div className="absolute">
                        <div className="flex flex-col items-center">
                            <MdAddAPhoto className='w-9 h-9' />
                            <span className="block text-gray-400 font-normal">Add Photo</span>
                        </div>
                    </div>
                    <input type="file" name="grimage" onChange={onChange} className="h-full w-full opacity-0" />
                </div>
            </div>
            {errorMsg && <div className='flex flex-row justify-center items-center w-full'>
                <p className='text-sm text-red-600'>{errorMsg}</p>
            </div>}
            <div className="flex gap-4 w-full flex-col">
                <label className="createFormLabels block" htmlFor="group_type">
                    Group Type {typeof(isPrivate)}
                </label>
                <select className='border createFormInput h-[50px] px-4 rounded-[10px]' value={isPrivate} onChange={(e) => setIsPrivate(e.target.value === "true")}>
                    <option>Select</option>
                    <option value={false}>Public</option>
                    <option value={true}>Private</option>
                </select>
            </div>
            {isPrivate &&
            <div className='gsgrouppasscodediv'>
                <p className='gspasscodelabel'>Passcode (4+ characters)</p>
                <div className="relative w-full">
                <input type={showPassword ? "text" : "password"} className='gsinputgrouppasscode w-full' value={grpasscode} onChange={(e) => setGrpasscode(e.target.value)} />
                <div onClick={() => setShowPassword(!showPassword)} className="absolute top-1/2 right-3 -mt-2 text-gray-600">
                    {showPassword ?
                    <BiShow /> : <BiHide />}
                </div>
                </div>
                {passcodeError && <p className='text-sm text-red-600'>{passcodeError}</p>}
            </div>}
            <div className='gssubmitbtndiv mt-5'>
                <button className='gssavebtn' onClick={updateSettings}>
                    {sloading ? 
                        <>
                        <svg role="status" className="inline mr-1 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                        </svg> Save Changes
                        </> : 'Save Changes'
                    }
                </button>
                <button className='gsdeletebtn' onClick={() => setDeleteModal(true)}>Delete Group</button>
            </div>
            {deleteModal ? 
            <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative p-4 w-full max-w-md h-full md:h-auto">
                    <div className="relative bg-white rounded-lg shadow">
                        <button type="button" onClick={() => setDeleteModal(false)} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" data-modal-toggle="popup-modal">
                            <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipule="evenodd"></path></svg>
                            <span className="sr-only">Close modal</span>
                        </button>
                        <div className="p-6 text-center">
                            <svg aria-hidden="true" className="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                            <h3 className="mb-1 text-lg font-normal text-gray-500">Are you sure you want to delete this group?</h3>
                            <h3 className="mb-5 text-sm font-normal text-gray-500">You will be deleting all its individual questions and activities too!</h3>
                            <button onClick={deleteGroupHandler} data-modal-toggle="popup-modal" type="button" className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                                Yes, I'm sure
                            </button>
                            <button data-modal-toggle="popup-modal" onClick={() => setDeleteModal(false)} type="button" className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">No, cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </> : null
            }
            </div>
        </div>
    </div>
    
  )
}

export default GroupGeneral